import {useMutation} from 'react-apollo'
import gql from 'graphql-tag'

import {FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION} from '../hooks'

const READ_REJECTED_DEPOSIT_METHOD_ISSUE_MUTATION = gql`
  mutation($depositMethodIssueVerificationId: Int!) {
    readRejectedDepositMethodIssue(depositMethodIssueVerificationId: $depositMethodIssueVerificationId) {
      id
      accountId
      clientId
      paymentMethodOptionId
      fileUrl
      fileName
      processStatus
      comment
      meta
      internalRemark
      createdAt
      updatedAt
      __typename
    }
  }
`

function useReadRejectedMessage() {
  const [mutation, {loading}] = useMutation(READ_REJECTED_DEPOSIT_METHOD_ISSUE_MUTATION, {
    refetchQueries: [{query: FETCH_CLIENT_DEPOSIT_METHOD_ISSUE_VERIFICATION}]
  })

  const readRejectedDepositMethodIssueMessage = (depositMethodIssueVerificationId) =>
    mutation({variables: {depositMethodIssueVerificationId}})

  return {readRejectedDepositMethodIssueMessage, submitting: loading}
}

export {useReadRejectedMessage}
